export const validateEmail = (email) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(email);
export const noSpecialCharIncluded = (value) => !(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(value));
export const contentIsNotNull = (value, min, max=5000) => value?.length > min && value?.length <= max;
